import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import {
  Grid, FormLabel, TextField, Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import { editLoginName } from '../../actions/employee.action';
import { trimWhitespaces } from '../../utils/strings';

const LoginName = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const employee = useSelector(state => state.employee);
  const [ loginName, setLoginName ] = useState(employee.loginName);
  const [ isLoginNameValid, setIsLoginNameValid ] = useState(true);

  useEffect(() => {
    setLoginName(employee.loginName);
  }, [ employee ]);

  const handleOnChangeLoginName = event => {
    setLoginName(trimWhitespaces(event.target.value));
    setIsLoginNameValid(trimWhitespaces(event.target.value).length !== 0);
  };

  const handleOnSaveLoginName = () => {
    if (isLoginNameValid) {
      dispatch(editLoginName(loginName));
    }
  };

  const useStyles = makeStyles({
    saveBtn: {
      marginTop: '10px'
    },
    label: {
      color: '#999999',
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    textField: {
      paddingTop: '15px'
    }
  });

  const classes = useStyles();

  return (
    <>
      <Grid item>
        <FormLabel className={ classes.label }>
          { t('settings.loginName.title') }
        </FormLabel>
        <TextField
          className={ classes.textField }
          value={ loginName }
          error={ !isLoginNameValid }
          helperText={ isLoginNameValid ? '' : t('settings.loginName.missing') }
          onChange={ handleOnChangeLoginName }
          fullWidth
          placeholder={ t('settings.loginName.placeholder') }
        />
        <Grid container justifyContent="flex-end">
          <Button
            onClick={ handleOnSaveLoginName }
            color="primary"
            variant="contained"
            disabled={ !loginName || loginName === employee.loginName }
            className={ `${classes.saveBtn} save-userName` }
          >
            <div>{ t('settings.loginName.save') }</div>
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default LoginName;
